var _defs, _polygon, _path, _path2, _path3, _path4, _path5, _path6, _circle, _polyline;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIllustrationsStep3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 72 72",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#dadede;}.cls-1,.cls-2{stroke:#556262;}.cls-1,.cls-2,.cls-5{stroke-miterlimit:10;}.cls-2,.cls-5{fill:none;}.cls-3{fill:#9da4a4;}.cls-4{fill:#5dd9c5;stroke:#18a795;stroke-linejoin:round;}.cls-5{stroke:#fff;stroke-linecap:round;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Illustrations") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "59.5 19.5 57.5 20.38 55.5 19.5 53.5 20.38 51.5 19.5 49.5 20.38 47.5 19.5 45.5 20.38 43.5 19.5 41.5 20.38 39.5 19.5 37.5 20.38 35.5 19.5 33.5 20.38 31.5 19.5 29.5 20.38 27.5 19.5 25.5 20.38 23.5 19.5 21.5 20.38 19.5 19.5 17.5 20.38 15.5 19.5 13.5 20.38 11.5 19.5 11.5 20.38 11.5 21.25 11.5 58 59.5 58 59.5 21.69 59.5 19.5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M29.5,20.5v-7s0-5,6-5,6,5,6,5v7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M45.43,39.65H39.94v-1h5.49a2,2,0,0,0,2-2v-3a2,2,0,0,0-2-2H39.94v-1h5.49a3,3,0,0,1,3,3v3A3,3,0,0,1,45.43,39.65Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M45.44,47.65h-5.5v-1h5.5a2,2,0,0,0,2-2v-3a2,2,0,0,0-2-2h-5.5v-1h5.5a3,3,0,0,1,3,3v3A3,3,0,0,1,45.44,47.65Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M39.93,47.65H25.44a2,2,0,0,1-2-2v-13a2,2,0,0,1,2-2h15v17Zm-14.49-16a1,1,0,0,0-1,1v13a1,1,0,0,0,1,1h14v-15Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M33.94,43.65h-6.5v-5h6.5a2.5,2.5,0,0,1,0,5Zm-5.5-1h5.5a1.5,1.5,0,1,0,0-3H28.44Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M33.94,39.65h-6.5v-5h6.5a2.5,2.5,0,0,1,0,5Zm-5.5-1h5.5a1.5,1.5,0,1,0,0-3H28.44Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 57.5,
    cy: 21.5,
    r: 6.5
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-5",
    points: "54.5 21.5 56.5 23.5 61 19"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustrationsStep3);
export default __webpack_public_path__ + "static/media/Illustrations_Step3.20b040b2fe8e8869dab4d40f3458a4d1.svg";
export { ForwardRef as ReactComponent };